// @flow
import React from "react";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import Hr from "elevate-ui/Hr";

type $Props = {
  classes: Object,
};

const DMCABody = ({ classes }: $Props) => (
  <div className={classes.root}>
    <Typography type="heading2" gutterTop gutterBottom>
      DMCA NOTICE
    </Typography>
    <Hr />
    <Typography type="heading4" gutterTop gutterBottom>
      Claims of Copyright Infringement and Related Issues
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      We respect the intellectual property rights of others. Anyone who believes
      their work has been reproduced in a way that constitutes copyright
      infringement may notify our agent by providing the following information:
    </Typography>
    <ol>
      <li>
        Identification of the copyrighted work that you claim has been
        infringed, or, if multiple copyrighted works at a single online site are
        covered by a single notification, a representative list of such works at
        the site;
      </li>
      <li>
        Identification of the material that you claim is infringing and needs to
        be removed, including a description of where it is located so that the
        copyright agent can locate it;
      </li>
      <li>
        Your address, telephone number, and, if available, e-mail address, so
        that the copyright agent may contact you about your complaint;
      </li>
      <li>
        A signed statement that the above information is accurate; that you have
        a good faith belief that the identified use of the material is not
        authorized by the copyright owner, its agents, or the law; and, under
        penalty of perjury, that you are the copyright owner or are authorized
        to act on the copyright owner’s behalf in this situation.
      </li>
    </ol>
    <Typography type="body" gutterTop gutterBottom>
      Upon obtaining such knowledge we will act expeditiously to remove, or
      disable access to, the material. Please be aware that there are
      substantial penalties for false claims.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      If a notice of copyright infringement has been wrongly filed against you,
      you may submit a counter notification to our agent. A valid counter
      notification is written communication that incorporates the following
      elements:
    </Typography>
    <ol>
      <li>A physical or electronic signature of the poster;</li>
      <li>
        Identification of the material that has been removed or to which access
        has been disabled and the location at which the material appeared before
        it was removed or access to it was disabled;
      </li>
      <li>
        A statement under penalty of perjury that you have a good faith belief
        that the material was removed or disabled as a result of mistake or
        misidentification;
      </li>
      <li>
        Your name, address, and telephone number; a statement that you consent
        to the jurisdiction of federal district court for the judicial district
        in which your address is located, or if your address is located outside
        of the U.S., for any judicial district in which the service provider may
        be found; and that you will accept service of process from the
        complainant.
      </li>
    </ol>
    <Typography type="body" gutterTop gutterBottom>
      Notices of the foregoing copyright issues should be sent as follows:
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <div>By mail:</div>
      <div>Copyright Compliance Office</div>
      <div>201 S Elm Street</div>
      <div>Greensboro, NC 27401</div>
      <a href="tel:1-336-722-3456">Phone: 336-722-3456</a>
      <div>Fax: 336-723-7464</div>
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <div>By e-mail:</div>
      <a href="mailto:copyrightcompliance@elmstreettechnology.com?Subject=DMCA">
        copyrightcompliance@elmstreettechnology.com
      </a>
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      If you give notice of copyright infringement by e-mail, an agent may begin
      investigating the alleged copyright infringement; however, we must receive
      your signed statement by mail or as an attachment to your e-mail before we
      are required to take any action.
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      In addition, if you believe in good faith that a notice of copyright
      infringement has been wrongly filed against you, the DMCA permits you to
      send us counter-notice. Notices and counter-notices must meet statutory
      requirements imposed by the DMCA. You acknowledge that if you fail to
      comply with all of the notice requirements of the DMCA, your notice may
      not be valid. One place to find more information is the U.S. Copyright
      Office Web site, currently located at
      <a
        href="https://www.copyright.gov"
        target="_blank"
        rel="noopener noreferrer"
      >
        {" "}
        https://www.copyright.gov.
      </a>
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      This information should not be construed as legal advice. We recommend you
      seek independent legal counsel before filing a notification or
      counter-notification. For further information about the DMCA, please visit
      the website of the United States Copyright Office at:
      <a
        href="http://www.copyright.gov"
        target="_blank"
        rel="noopener noreferrer"
      >
        {" "}
        http://www.copyright.gov.
      </a>
    </Typography>
    <Typography type="body" gutterTop gutterBottom>
      <em>
        Please note: If you materially misrepresent that online material,
        product, or activity is infringing your copyrights, you may be liable
        for damages (including court costs and attorneys' fees) and could be
        subject to criminal prosecution for perjury. We suggest that you consult
        your legal advisor before filing a notice or counter-notice.
      </em>
    </Typography>
    <Typography type="heading4">Termination</Typography>
    <Typography type="body" gutterTop gutterBottom>
      You may stop using the Site at any time. Elm Street Technology, LLC may
      suspend or terminate the Site at any time at Elm Street Technology, LLC's
      discretion and without notice. Elm Street Technology, LLC may also
      terminate, limit or suspend your access to the Site for any reason at any
      time and without notice. For example, Elm Street Technology, LLC may
      terminate your access to this Site if you are not complying with these
      Terms or if Elm Street Technology, LLC determines that you are a repeat
      infringer of third-party intellectual property rights.
    </Typography>
  </div>
);

const styles = (theme) => ({
  root: {
    position: "relative",
    width: "100%",
    maxWidth: "970px",
    margin: "48px auto",
    fontSize: "14px",
    "& p": {
      maxWidth: "100%",
    },
    "& ol": {
      margin: "28px",
      listStyle: "decimal",
      fontSize: "14px",
      "& li": {
        marginBottom: theme.spacing.unit * 0.75,
      },
    },
  },
});

export default withStyles(styles)(DMCABody);
